import client from '../client'
import qs from 'qs'

export const getPointHistory = async ({ lastPosNo, limit }) => {
  const queryString = qs.stringify({
    last_pos_no: lastPosNo,
    limit,
    order_by: 'no',
  })
  const response = await client.get(`/point?${queryString}`)

  return response.data
}
